jQuery(document).ready(function() {
    var $ = jQuery;

    // hide nav on scroll down, show nav on scroll up
    const headerElem  = $('#header');
    const secHeaderHeight = $('#secondary-header').outerHeight();

    // set top of header = to secondary-header-height
    if ($(document).scrollTop() == 0) {
        $(headerElem).css('top', `${secHeaderHeight}px`);
    }

    if( document.getElementById('scrollTrigger') )
    {
        $(window).on('scroll', function() {

            const primaryScrollPos = $('#scrollTrigger').position().top;
            const headerHeight = headerElem.outerHeight();
            const secHeaderHeight = $('#secondary-header').outerHeight();

            // secondary-header only visible at top of page
            if ($(document).scrollTop() == 0 ) {
                $(headerElem).css('top', `${secHeaderHeight}px`);
                $('#content').css('padding-top', `${headerHeight}px`);
            } else {
                $(headerElem).css('top', '0');
                $('#content').css('padding-top', `${headerHeight - secHeaderHeight}px`);
            }

            // Catch false equivelance glitch
            if ( this.oldScroll === this.scrollY ) {
                return null;
            } else if ( this.oldScroll >= this.scrollY || this.scrollY < 0 ) {
                $(headerElem).removeClass('hide');
            } else if ( this.scrollY >= primaryScrollPos - secHeaderHeight) {
                $(headerElem).addClass('hide');
            }

            this.oldScroll = this.scrollY;
        
        });
    }

    $(window).on('resize', function() {
        const headerHeight = headerElem.outerHeight();
        const secHeaderHeight = $('#secondary-header').outerHeight();
        // set top of header = to secondary-header-height
        $(headerElem).css('top', `${secHeaderHeight}px`);
        $('#content').css('padding-top', `${headerHeight}px`);
    });

});